import { api } from '@services';

import qs from 'query-string';
import { IGetStudioUpdates } from '../getStudioUpdates/getStudioUpdates';

interface IRequest {
  id: string;
  filter?: IGetStudioUpdates;
  search?: string;
}

export interface IGetStudioUpdatesMetrics {
  new: number;
  prioritized: number;
  completed: number;
  dismissed: number;
  assignedToMe: number;
}

const getStudioUpdatesMetrics = async ({
  id,
  filter,
  search,
}: IRequest): Promise<IGetStudioUpdatesMetrics> => {
  const query = {
    q: search,
    manufactorNames: filter?.manufactorNames?.join(','),
    tagsNames: filter?.tagsNames?.join(','),
    dateStart: filter?.dateStart
      ? new Date(filter.dateStart).toJSON()
      : undefined,
    dateEnd: filter?.dateEnd ? new Date(filter.dateEnd).toJSON() : undefined,
  };

  const queryString = qs.stringify(query);

  const { data: numbers } = await api.get<IGetStudioUpdatesMetrics>(
    `/studios/${id}/updatesMetrics?${queryString}`,
  );

  return numbers;
};

export { getStudioUpdatesMetrics };
